import * as Sentry from "@sentry/react";
import ReactGA from "react-ga4";
import { appShellName, appSystemInfo } from "./utils/environment";
import { isProdEnv } from "@fokused-me/core";

Sentry.init({
   dsn: "https://bc70cfe503c647aabe8df0ab3893659a@o184281.ingest.sentry.io/5659234",
   normalizeDepth: 10,
   release: `fokused-me@${appSystemInfo.version}`,
   enabled: isProdEnv(),
});

import "./index.css";
import "@fontsource/roboto";
import "@fontsource/roboto-mono";
import "core-js/features/map";
import "core-js/features/set";
import "core-js/features/array";
import "core-js/features/symbol";
import "core-js/features/number";
import "core-js/features/object";

import * as ReactDOM from "react-dom";

import { App } from "./App";
import registerServiceWorker from "./utils/registerServiceWorker";

// if (isProdEnv()) {
   ReactGA.initialize("G-845WVDJB5Q");

   ReactGA.set({
      appVersion: appSystemInfo.version,
      appName: appShellName,
      // ...appStats,
      // ...gaCampaignParams,`
   });

   ReactGA.send('pageview');
// }

console.log(
   "System info: %s",
   JSON.stringify({
      appSystemInfo,
      appShellName,
      env: process.env,
   })
);

// import { Settings } from "./state/Settings";

// throw new Error("This is new error");

// function processLocation(loading: boolean): Promise<any> {
//    const commands = document.location.hash.replace(/#/, "").split("&");
//    commands
//       .filter((it) => it && it.length)
//       .forEach((command) => {
//          if (command === "action:reset") {
//             setTimeout(() => {
//                resetAllAppData().then(() => {
//                   document.location.href = "";
//                });
//             }, 500);
//          } else if (command.indexOf("referrer:") === 0) {
//             try {
//                // utm_source%3Dgoogle%26utm_medium%3Dcpc%26utm_term%3Dproductivity%252Bapp%26utm_content%3Dad-content%26utm_campaign%3Dad-name%26anid%3Dadmob
//                const [, referrer] = command.split(":");
//                if (referrer) {
//                   (window as any).installReferrer = decodeURIComponent(referrer);
//                }
//             } catch (e) {
//                //
//             }
//          }
//       });

//    return Promise.resolve();
// }

// history / [back] button handling
// window.addEventListener("load", () => {
// const completeLoad = () => {
//    window.history.replaceState({}, "", "/");
//    window.history.pushState({}, "");
//    reduxStore.dispatch<any>(initApp);
// };
// processLocation(true).then(completeLoad);
// });

// window.addEventListener("popstate", (event) => {
//    processLocation(false);
// .then(() => reduxStore.dispatch<any>(handleBackButton));
// });

// window.addEventListener("keyup", (event) => {
// if (event.key === 'Escape') {
//    reduxStore.dispatch<any>(handleCancelMode);
// }
// });

// (window as any).onAndroidAppShellIntent = (intent: IAndroidIntent) => {

// };

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);

// ReactDOM.render(
//    <Provider store={reduxStore}>
//       <App />
//    </Provider>,
//    document.getElementById("root") as HTMLElement
// );

// ReactDOM.render(
//    <div>
//       <Dialogs />
//       <Snackbars />
//    </div>,
//    document.getElementById("dialogs") as HTMLElement
// );

registerServiceWorker();
